var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5294 4.9512L18.2153 5.44598C19.8222 6.60664 21.0109 8.25564 21.6041 10.1471C22.1972 12.0385 22.1631 14.071 21.5068 15.9414C20.8504 17.8119 19.6071 19.42 17.9621 20.5261C16.3171 21.6321 14.3586 22.1768 12.3788 22.0789C10.399 21.981 8.50384 21.2457 6.97604 19.9827C5.44824 18.7197 4.36964 16.9966 3.90111 15.0705C3.43257 13.1445 3.59919 11.1185 4.37613 9.29487C5.15308 7.47122 6.4987 5.94758 8.21233 4.95117",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8331 1.2669L12.8389 12.9037",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.5dd8da5c3e48e07a62cfb9f6420be996.svg";
export { ForwardRef as ReactComponent };